import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-read-only",
  "use": "icon-read-only-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" id=\"icon-read-only\"><path d=\"m10.596 15.804 1.823.977L9.6 19.6l2.8 2.8 3.665-3.665 1.824.976L12.4 25.2 4 28l2.8-8.4zM8.4 21l-1.2 3.8 3.6-1.4zM24 4c1 0 2 .4 2.8 1.2 1.547 1.547 1.598 3.84.155 5.437l-.155.163-6.178 6.177L30 22v2.2L2 9.2V7l11.329 6.07L21.2 5.2c.738-.738 1.647-1.136 2.57-1.193zm-4.2 5.4-4.647 4.646L18.799 16l3.801-3.8zM24 6c-.6 0-1 .2-1.4.6l-1.2 1.2 2.8 2.8 1.195-1.195C25.8 9 26 8.6 26 8s-.2-1-.6-1.4S24.6 6 24 6\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol